module.exports = __webpack_public_path__ + "static/media/9.692841c3.jpg";